import { EventInput } from "@fullcalendar/core/index.js";
import { format } from "date-fns";

import { AppointmentResponse, AttendanceType, PurposeType } from "@/api";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { ITranslation, LanguageType } from "@/translations";

export const isAttendanceAppointment = (appointment: AppointmentResponse) =>
  appointment.purposeType === PurposeType.Attendance;

export const isAbsentAttendanceAppointment = (appointment: AppointmentResponse) =>
  isAttendanceAppointment(appointment) && appointment.attendanceType === AttendanceType.Absent;

export const formatAttendanceLabel = (
  appointment: AppointmentResponse,
  purposeLabel: string,
  t: ITranslation,
  language: LanguageType
): string => {
  const parts: string[] = [purposeLabel];

  if (!isAbsentAttendanceAppointment(appointment)) {
    const locale = locales[language as LanguageType];
    const from = format(new Date(appointment.startTimeUtc), "p", { locale });
    const to = format(new Date(appointment.endTimeUtc), "p", { locale });
    parts.push(t("calendar.attendanceLabel.timeRange", { from, to }));
  }

  if (appointment.substituteCounselorUserCode) {
    parts.push(`(${t("calendar.attendanceLabel.substitute", { userCode: appointment.substituteCounselorUserCode })})`);
  }

  return parts.join(" ");
};

export const mapAppointmentEvent = (appointment: AppointmentResponse): EventInput => ({
  id: appointment.appointmentId,
  start: appointment.startTimeUtc,
  end: appointment.endTimeUtc,
  allDay: appointment.isAllDay,
  extendedProps: { originalEvent: appointment },
});

export const mapAbsenceBackgroundEvent = (appointment: AppointmentResponse): EventInput => ({
  ...mapAppointmentEvent(appointment),
  display: "background",
  classNames: ["absence-event"],
});
